import { useState, useEffect } from 'react'
import { Icon } from '@iconify/react'
import { useGlobalContext } from '../../../../utils/Context'
import { get } from '../../../../utils/Api'
import FormLoader from '../../../../components/loader/FormLoader'
import Pagination from '../../../../components/pagination/Pagination'

function WalletTrail() {
  const { notify, fetchBusiness, businessLoading, business } =
    useGlobalContext()
  const [transactions, setTransactions] = useState<any>({ transactions: [] })
  const [transactionsLoading, setTransactionsLoading] = useState(true)
  const [paginationPage, setPaginationPage] = useState('default')

  function fetchTransactions(page: number, pageSize: number) {
    setTransactionsLoading(true)
    get(`business_admin/wallet-trails?page=${page}&limit=${pageSize}`)
      .then((result: any) => {
        if (result.status === 200) {
          setTransactions(result.data)
        } else {
          notify('error', result.message)
        }
        setTransactionsLoading(false)
      })
      .catch(() => {
        setTransactionsLoading(false)
      })
  }
  const fetchFilteredTransactions = async (page: number, pageSize: number) => {
    setTransactionsLoading(true)
    get(
      `business_admin/wallet-trails?from=${dates.from}&to=${dates.to}&page=${page}&limit=${pageSize}`,
    )
      .then((result: any) => {
        if (result.status === 200) {
          setTransactions(result.data)
        } else {
          notify('error', result.message)
        }
        setTransactionsLoading(false)
      })
      .catch(() => {
        setTransactionsLoading(false)
      })
  }
  useEffect(() => {
    fetchBusiness()
    fetchTransactions(1, 10)
  }, [])

  //Filter
  const [dates, setDates] = useState({
    from: '',
    to: '',
  })
  const handleChange = (e: any) => {
    const { name, value } = e.target
    setDates((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }
  function handleFilter() {
    if (!dates.from || !dates.to) {
      notify('error', `Dates can't be empty`)
    } else {
      setPaginationPage('date')
      fetchFilteredTransactions(1, 10)
    }
  }

  return (
    <div className='home'>
      <div className='home_tag flex justify-between items-center'>
        <h1></h1>
        <div className='flex items-center select-wrapper'>
          <div className='flex items-center'>
            <p></p>
            <input
              type='date'
              name='from'
              value={dates.from}
              onChange={handleChange}
              max={new Date().toISOString().split('T')[0]}
            />
          </div>
          <div className='flex items-center'>
            <p>to</p>
            <input
              type='date'
              name='to'
              value={dates.to}
              onChange={handleChange}
              min={dates.from}
              max={new Date().toISOString().split('T')[0]}
            />
          </div>

          <button disabled={!dates.from || !dates.to} onClick={handleFilter}>
            filter
          </button>
        </div>
      </div>
      <div
        className='home-head flex justify-between flex-wrap'
        style={{ marginTop: 0 }}
      >
        <div className='left flex justify-between flex-wrap'>
          <div className='card'>
            <p>Total Wallet Ballance</p>
            <h2>
              ₦
              {businessLoading
                ? '....'
                : parseFloat(business.balance.toFixed(2)).toLocaleString()}
            </h2>
          </div>
        </div>
      </div>

      <div className='home_tables'>
        <div className='left'>
          {transactionsLoading ? (
            <FormLoader position='center' />
          ) : (
            <>
              {transactions.trails.length > 0 ? (
                <>
                  <div className='mobile-table'>
                    {transactions.trails.map((item: any, i: number) => (
                      <div className='card'>
                        <div className='flex justify-between row'>
                          <div className='count flex items-center justify-center'>
                            {i + 1}
                          </div>
                          <p> {new Date(item.createAt).toLocaleString()}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Amount</h4>
                          <p>₦{item.amount.toLocaleString()}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Amount Before</h4>
                          <p>₦{item.amountBefore.toLocaleString()}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Amount After</h4>
                          <p>₦{item.amountAfter.toLocaleString()}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Usage</h4>
                          <p>{item.usage}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <table className='desktop-table'>
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Date/Time</th>
                        <th>Amount</th>
                        <th>Amount Before</th>
                        <th>Amount After</th>
                        <th>Usage</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.trails.map((item: any, i: number) => (
                        <tr key={item._id}>
                          <td>{i + 1}</td>
                          <td className='count'>
                            {new Date(item.createdAt).toLocaleString()}
                          </td>
                          <td className='count'>
                            NGN {item.amount.toLocaleString()}
                          </td>
                          <td>NGN {item.amountBefore.toLocaleString()}</td>
                          <td>NGN {item.amountAfter.toLocaleString()}</td>
                          <td>{item.usage}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={transactions.pagination.page}
                    totalCount={transactions.pagination.totalPages}
                    pageSize={transactions.pagination.limit}
                    onPageChange={(page: number, pageSize: number) => {
                      paginationPage === 'default'
                        ? fetchTransactions(page, pageSize)
                        : fetchFilteredTransactions(page, pageSize)
                    }}
                  />
                </>
              ) : (
                <div className='empty flex justify-center'>
                  <div className='empty-cover'>
                    <Icon icon='la:clipboard-list' />
                    <h1>No Outstanding Trail To Show</h1>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default WalletTrail
